export const VALID_DPI = 300;

export const pegHoleTypes = [
    {
        value: "ES1",
        text: "Euro Slot 25mm",
    },
    {
        value: "ES2",
        text: "Euro Slot 33mm",
    },
    {
        value: "HH1",
        text: "Hole Hook",
    },
    {
        value: "RL1",
        text: "Round hole",
    },
    {
        value: "SL1",
        text: "Slot hole 10mm",
    },
    {
        value: "SL3",
        text: "Slot hole 7mm",
    },
];
